import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { getCrmSessionToken } from '../crm/utils/crmEnv';

const PortalGuard = ({ children }) => {
    const location = useLocation();
    const token = getCrmSessionToken();

    if (!token) {
        return (
            <Redirect
                to={{
                    pathname: '/crm-portal/login',
                    state: { from: location.pathname },
                }}
            />
        );
    }

    return children;
};

export default PortalGuard;
